<app-confirmation-dialog [props]="props" id="wallet-alert-config-dialog">
  <div class="modal-content-container" id="wallet-alert-config-content">
    <div class="wallet-name" id="wallet-alert-config-name-container">
      <i class="fas fa-briefcase" id="wallet-alert-config-icon-wallet"></i>
      <span id="wallet-alert-config-span-name">{{walletName}}</span>
    </div>

    <app-tab-control [tabs]="tabs" id="wallet-alert-config-tab-control">
      <ng-template #attributesTabContent>
        <app-wallet-attributes-tab
          id="wallet-alert-config-tab-attributes"
          [walletId]="wallet.id"
          [isAlert30Days]="isAlert30Days"
        ></app-wallet-attributes-tab>
      </ng-template>

      <ng-template #emailsTabContent>
        <app-wallet-emails-tab
          id="wallet-alert-config-tab-emails"
          [walletId]="wallet.id"
          [isAlert30Days]="isAlert30Days"
        ></app-wallet-emails-tab>
      </ng-template>
    </app-tab-control>
  </div>
</app-confirmation-dialog>
